<template>
    <div class="control">
        <b-tag v-if="!payGrade" :type="type" :size="size"><strong>{{$t('skills.' + skill.name + '.name')}}</strong></b-tag>

        <b-taglist v-else attached>
            <b-tag :type="type" :size="size">
                <strong>{{$t('skills.' + skill.name + '.name')}}:</strong>&nbsp;

                <price :payGrade="payGrade" />
            </b-tag>
        </b-taglist>
    </div>
</template>

<script>
    import Price from '@/taskflex/skills/components/Price';

    export default {
        props: {
            skill: {
                type: Object,
                required: true,
            },

            payGrade: {
                type: Object,
                required: false,
                default: null,
            },

            type: {
                type: String,
                required: false,
                default: '',
            },

            size: {
                type: String,
                required: false,
                default: 'is-small',
            },

            sameType: {
                type: Boolean,
                required: false,
                default: false,
            },
        },

        components: {
            Price,
        },
    };
</script>




// WEBPACK FOOTER //
// src/taskflex/skills/components/SkillTag.vue